import api from "@/lib/api";

// Fire-and-forget internal funnel tracking. Never blocks the UI.
export function track(event, propertyId = null, meta = {}) {
  try {
    api.post("/analytics/event", { event, property_id: propertyId, meta }).catch(() => {});
  } catch { /* noop */ }
}
